import Vue from 'vue'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'FgqaqqsX8dieNjkUph62UV8NgCbaB6vo'
})
